import { render, staticRenderFns } from "./Skiptirmali.vue?vue&type=template&id=a8633de4&scoped=true"
import script from "./Skiptirmali.vue?vue&type=script&lang=js"
export * from "./Skiptirmali.vue?vue&type=script&lang=js"
import style0 from "./Skiptirmali.vue?vue&type=style&index=0&id=a8633de4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8633de4",
  null
  
)

export default component.exports